<template>
    <div class="uploadlager">
        <router-view></router-view>
        <div class="uploadlagertop"></div>
        <div class="uploadlagerHolder">
            <div class="lageruploadtitle">file upload</div>
            <select v-model="action">
                <option value="new">neue Artikel</option>
                <option value="storage">Lagerort / Bestand</option>
            </select>
            delimiter:
            <select v-model="delimiter">
                <option value=";">;</option>
                <option value=",">,</option>
            </select>
            <input id="lagerfileupload" type="file" accept=".csv" @change="uploadFile()">
            <div class="csvexplaindiv">
                Die Files müssen im <a href="https://de.wikipedia.org/wiki/CSV_(Dateiformat)" target="_blank">CSV</a>
                Format hochgeladen werden.
                Diese Dateien können mit Excel genereirt werden. Oder von Hand in einem Texteditor. <br>
                Spalten dürfen leer sein.<br>
                Nicht mehr als 500 Artikel aufs Mal.
                <div v-if="action === 'storage'">
                    <br>
                    Falls es Artikel im CSV gib die noch nicht in der DB erfasst sind, wird ein CSV generiert mit diesen
                    Artikeln.
                    <br>
                    1. Artikel nummer<br>
                    2. Mindestbestand<br>
                    3. Istbestand<br>
                    4. Lager Kapazität<br>
                    5. Lagerort<br>
                    6. Mengeneinheit (zB: Stk, Packung, Fass)<br>
                    7. Stück Pro Einheit (Wie viel Stücke gibt es pro Mengeneinheit)<br>
                    8. als Packung bestellt werden<br>
                    9. SRM<br>
                    10. SFS<br>
                    11. EM<br>
                    <br>
                    z.B:<br>
                    "815-00-230"{{this.delimiter}}"3"{{this.delimiter}}"6"{{this.delimiter}}"10"{{this.delimiter}}"AKL1-2-3"{{this.delimiter}}"Stk"{{this.delimiter}}"1"{{this.delimiter}}"0"{{this.delimiter}}"1"{{this.delimiter}}"0"{{this.delimiter}}"0"<br>
                    "823-01-23A"{{this.delimiter}}"2"{{this.delimiter}}"8"{{this.delimiter}}"21"{{this.delimiter}}EG1-0-2"{{this.delimiter}}"Packung"{{this.delimiter}}"10"{{this.delimiter}}"1"{{this.delimiter}}"0"{{this.delimiter}}"1"{{this.delimiter}}"0"<br>
                    "723-12-23"{{this.delimiter}}""{{this.delimiter}}""{{this.delimiter}}""{{this.delimiter}}"EG1-0-2"{{this.delimiter}}"Stk"{{this.delimiter}}"1"{{this.delimiter}}"0"{{this.delimiter}}"0"{{this.delimiter}}"0"{{this.delimiter}}"1"<br>

                </div>
                <div v-if="action === 'new'">
                    <br>
                    1. Artikel nummer<br>
                    2. Artikel Kurztext<br>
                    3. Artikel Langtext<br>
                    <br>
                    <br>
                    z.B:<br>
                    "815-00-230"{{this.delimiter}}"Irgendetwas"{{this.delimiter}}"Irgendetwas. Wird wohl wichtig
                    sein"<br>
                    "823-01-23A"{{this.delimiter}}""{{this.delimiter}}""<br>
                    "723-12-23"{{this.delimiter}}"Something"{{this.delimiter}}"Something something dark side"<br>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import http from '../../http/http';

export default {
    components: {},
    data() {
        return {
            action: 'storage',
            delimiter: ';'
        }
    },
    props: {
        stao: {
            type: String,
            default: '1'
        }
    },
    computed: {
        apiurl() {
            return http.defaults.baseURL;
        }

    },
    watch: {},
    methods: {
        uploadFile() {
            const data = {
                stao: this.stao,
                file: document.getElementById('lagerfileupload').files[0],
                url: this.apiurl,
                delimiter: this.delimiter
            };

            if (this.action === 'new') {
                this.$store.dispatch('lager/uploadFileNewArt', data);
            } else if (this.action === 'storage') {
                this.$store.dispatch('lager/uploadFileStorage', data);
            }
        }
    },
    beforeDestroy() {
    },
    created() {
    }
}
</script>

<style scoped lang="scss">

    .uploadlager {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $color-white;
    }

    .uploadlagerHolder {
        /*display: flex;
        flex-direction: column;*/
        width: 100%;
        padding: 0.625rem;
    }

    .lageruploadtitle {
        font-size: 2rem;
    }

    .uploadlagertop {
        height: 70px;
        width: 100%;
    }

    .csvexplaindiv {
        border-top: solid black;
        padding: 0.625rem;
        /*overflow-y: scroll;*/

    }

    @include medium {

        .uploadlagertop {
            display: none;
        }

        .uploadlagerHolder {
            width: 31rem;
            @include default-shadow;
        }
    }

    @include extra-large {

        .uploadlagerHolder {
            width: 31rem;
            @include default-shadow;
            height: 80vh;
        }
    }

</style>
